export default {
    header: "Sie wurden erfolgreich abgemeldet",
    message: ""
}